import { BarChart } from '../../../common/chart_bar';
import { LoadingDiscoWithContainer } from '../../../common/loading/loading-disco';
import { useQuery } from 'react-query';
import { APIConstants } from '../../../../helpers/constants';
import { SerieData } from '../../../../types/charts';
import { useTranslation } from 'react-i18next';

export const MonthlyBusinessCount = () => {
  const { t } = useTranslation();
  const token = localStorage.getItem('token');
  const { data, isLoading, error } = useQuery<SerieData[]>(['monthlyBusinessCount'], () =>
    fetch(`${APIConstants.BI_API_URL}/business-count-by-day`, {
      headers: [['Authorization', `Bearer ${token}`]],
      credentials: 'omit',
    }).then((res) => res.json())
  );
  return (
    <div className='h-96 shadow ring-1 ring-gray-200 ring-opacity-5 md:rounded-lg'>
      <h2 className='mx-auto py-2 pl-6 text-lg font-medium leading-6 text-gray-400'>
        {t('statistics.monthy_business_count')}
      </h2>
      {error ? (
        <div>{t('errors.generic')}</div>
      ) : !data || isLoading ? (
        <LoadingDiscoWithContainer />
      ) : (
        <BarChart data={data} chartType='bar' />
      )}
    </div>
  );
};
